var React = require('react');

function Checkmarkround (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"dst0","d":"M31.2 16c0 8.8-7 16-15.6 16S0 24.8 0 16 7 0 15.6 0c3.2 0 6.4 1 9 2.9.3.2.4.7.2 1-.2.3-.7.4-1 .1-2.4-1.7-5.2-2.6-8.2-2.6C7.8 1.4 1.4 8 1.4 16s6.4 14.6 14.2 14.6S29.8 24 29.8 16c0-.4.3-.7.7-.7s.7.3.7.7z","key":0}),React.createElement("path",{"className":"dst0","d":"M32.8 3.7c-.3-.3-.8-.3-1 0L16.5 19.4 10 12.7c-.3-.3-.7-.3-1 0s-.3.7 0 1l7 7.2c.1.1.3.2.5.2s.4-.1.5-.2L32.8 4.7c.3-.2.3-.7 0-1z","key":1})]);
}

Checkmarkround.defaultProps = {"fill":"#ce445b","id":"bulletred","viewBox":"0 0 33 32","width":"33","height":"32"};

module.exports = Checkmarkround;

Checkmarkround.default = Checkmarkround;
